
import React from 'react';
import FontAwesome from 'react-fontawesome'
import { HelpBlock, Tabs, Tab, Row, Col, ControlLabel, Form, FormGroup, FormControl, ButtonToolbar, Button } from 'react-bootstrap'
import Select from 'react-select'
import DatePicker from 'component/element/DatePicker'
import { Box } from 'reactjs-admin-lte'
import {connect} from 'react-redux'
import {Switch,Route,withRouter} from 'react-router-dom'
import No_img from 'asset/img/no_image.jpg'
import AssetStore from 'stores/AssetStore'
import ConfirmPopup from 'component/element/ConfirmPopup'
import AssetEditCategoryModal from './AssetEditCategoryModal'
const NotificationSystem = require('react-notification-system')
class AssetDoc extends React.Component {

  constructor(...args){
    super(...args)
    this.state = {
      activeKey:'info',
      loading:false,
      data:this.initData(),
      asset_id:'',
      showDel:false,
      category:[],
      sub_category:[],
      showCat:false,
      typeCat:'cat_id'
    }
  }

  initData() {
    return {
      added_by: "",
      added_date: "",
      asset_code: "",
      asset_id: "",
      asset_type: "",
      category: "0",
      category_name: "",
      cost_per_unit: "",
      detail: "",
      employee_id: null,
      first_used_date: "",
      last_used_date: "",
      location: "",
      purchase_date: "",
      remark: null,
      serial_no: "",
      sub_category: "0",
      sub_category_name: "",
      thumbnail_url: null,
      trash_flag: "0",
      unit: "",
      vehicle_id: "0",
      vehicle_registration_no: ""
    }
  }

  componentDidMount() {
    this._notificationSystem = this.refs.notificationSystem;
    this.setTab()
    if(this.props.showInfoOnly){
      this.loadData(this.props.assetId)
      this.loadReportAssetCategory()
      this.setState({asset_id:this.props.assetId})      
    }
  }

  componentWillReceiveProps(newProps) {
    if (!newProps.showTb&&newProps.showTb!==this.props.showTb&&newProps.action==='add') {
      this.onTabsSelect('info')
      this.setState({data:this.initData()})
      this.loadReportAssetCategory()
      this.setState({asset_id:''})
    } else if (!newProps.showTb&&newProps.showTb!==this.props.showTb&&newProps.action==='') {
      this.onTabsSelect('info')
      this.loadData(newProps.assetId)
      this.loadReportAssetCategory()
      this.setState({asset_id:newProps.assetId})
    }
  }

  loadData(asset_id) {
    this.setState({loading:true})
    AssetStore.loadReportAssetInfo(asset_id,(result)=>{
      this.setState({loading:false,data:result.data})
      if (result.data.category!==''&&result.data.category!==null&&result.data.category!==undefined&&result.data.category>0)
        this.loadReportAssetSubCategory(result.data.category)
    })
  }

  loadReportAssetCategory() {
    this.setState({loading:true})
    AssetStore.loadReportAssetCategory('',(result)=>{
      let category = []
      category = result.data.map((item,index)=>{
        return {label:item.name,value:item.cat_id}
      })
      this.setState({loading:false,category:category})
    })
  }

  loadReportAssetSubCategory(cat_id) {
    this.setState({loading:true})
    AssetStore.loadReportAssetCategory(cat_id,(result)=>{
      let sub_category = []
      sub_category = result.data.map((item,index)=>{
        return {label:item.name,value:item.cat_id}
      })
      this.setState({loading:false,sub_category:sub_category})
    })
  }

  setTab() {
    let {location} = this.props
    if (location.pathname.search('/asset/work/history')!==-1)
        this.onTabsSelect('history')
    else if (location.pathname.search('/asset/work/info')!==-1)
        this.onTabsSelect('info')
  }

  onTabsSelect(key) {
    this.setState({activeKey:key})
    // this.props.history.push({pathname:'/asset/work/'+key,search:'',state:{}})
  }

  onFormChange(field,e) {
    let {data} = this.state
    data[field] = e.target.value
    this.setState({data:data})
  }

  onDateChange(field,e) {
    let {data} = this.state
    data[field] = e
    this.setState({data:data})
  }

  onSaveClick() {
    let {data,asset_id} = this.state
    let postData = data
    AssetStore.saveAssetInfo(asset_id,postData,(result)=>{
      if (result.status==='OK') {
        this.setState({asset_id:result.asset_id})
        this._notificationSystem.addNotification({
            title: 'แจ้งเตือน',
            message: 'ทำรายการบันทึกใบงานสินทรัพย์ '+data.asset_code+' สำเร็จ',
            level: 'info',
            position: 'tc'
        });
      }
    },()=>{
      this._notificationSystem.addNotification({
        title: 'แจ้งเตือน',
        message: 'ไม่สามารถทำรายการบันทึกใบงานสินทรัพย์ได้',
        level: 'error',
        position: 'tc'
      });
    })
  }

  onConfirmDel() {
    let {asset_id,data} = this.state
    AssetStore.delAssetInfo(asset_id,(result)=>{
      if (result.status==='OK') {
        this.setState({showDel:false})
        this._notificationSystem.addNotification({
            title: 'แจ้งเตือน',
            message: 'ทำรายการลบใบงานสินทรัพย์ '+data.asset_code+' สำเร็จ',
            level: 'info',
            position: 'tc'
        });
        setTimeout(()=>{
          this.onClose()
        },500)
      }
    },()=>{
      this.setState({showDel:false})
      this._notificationSystem.addNotification({
        title: 'แจ้งเตือน',
        message: 'ไม่สามารถทำรายการลบใบงานสินทรัพย์ได้',
        level: 'error',
        position: 'tc'
      });
    })
  }

  onClose(){
    this.props.onClose()
    // this.props.history.push({pathname:'/asset/work/info',state:{}})          
  }

  onCategoryChange(e) {
    let {data} = this.state
    data.category = e.value
    data.sub_category = '0'
    this.setState({data:data})
    this.loadReportAssetSubCategory(e.value)
  }

  onSubCategoryChange(e) {
    let {data} = this.state
    data.sub_category = e.value
    this.setState({data:data})
  }

  onCategoryCloseClick() {
    this.setState({showCat:false,typeCat:'cat_id'})
  }

  onNewCategory() {
    this.loadReportAssetCategory()
  }

  onNewSubCategory(cat_id) {
    this.loadReportAssetSubCategory(cat_id)
  }

  onUpdateCategory(cat_id) {
    let {data} = this.state
    this.loadReportAssetCategory()
    if (data.category===cat_id) {
      data.category = '0'
      data.sub_category = '0'
      this.setState({data:data,sub_category:[]})
      this.onSaveClick()
    }
  }

  onUpdateSubCategory(sub_cat_id) {
    let {data} = this.state
    this.loadReportAssetSubCategory(data.category)
    if (data.sub_category===sub_cat_id) {
      data.sub_category = '0'
      this.setState({data:data})
      this.onSaveClick()
    }
  }

  renderImage() {
    return (
      <Row>
        <Col xs={12}>
          <img alt='' src={No_img} width="100%" height="100%" />
        </Col>
      </Row>
    )
  }

  renderInfoTab() {
    let {data,category,sub_category,asset_id} = this.state
    return(
      <div style={{padding:'10px'}}>
        <Box loading={this.state.loading}>
          <Box.Body>
            <Row>
              <Col md={6}>
                <FormGroup>
                  <ControlLabel>หมวดหมู่</ControlLabel>
                  <Select
                    clearable={false}
                    name="form-field-name"
                    placeholder='- เลือกหมวดหมู่ -'
                    value={data.category}
                    options={category}
                    onChange={this.onCategoryChange.bind(this)}
                  />
                  <FormControl.Feedback />
                  <HelpBlock>
                    <Button
                      bsStyle={'box-tool'} 
                      className='btn-box-tool'
                      onClick={()=>{this.setState({showCat:true,typeCat:'cat_id'})}}
                    >
                      <FontAwesome name='plus' /> เพิ่มหมวดหมู่
                    </Button>
                  </HelpBlock>
                </FormGroup>
              </Col>
              <Col md={6}>
                <FormGroup>
                  <ControlLabel>หมวดหมู่ย่อย</ControlLabel>
                  <Select
                    clearable={false}
                    name="form-field-name"
                    placeholder='- เลือกหมวดหมู่ย่อย -'
                    value={data.sub_category}
                    options={sub_category}
                    onChange={this.onSubCategoryChange.bind(this)}
                  />
                  <HelpBlock>
                    <Button
                      bsStyle={'box-tool'} 
                      className='btn-box-tool'
                      onClick={()=>{this.setState({showCat:true,typeCat:'sub_cat_id'})}}
                    >
                      <FontAwesome name='plus' /> เพิ่มหมวดหมู่ย่อย
                    </Button>
                  </HelpBlock>
                </FormGroup>
              </Col>
            </Row>
            <Row>
              <Col md={6}>
                <FormGroup>
                  <ControlLabel>ชื่อรายการ</ControlLabel>
                  <FormControl onChange={this.onFormChange.bind(this,'detail')} value={data.detail!==null?data.detail:''} />
                </FormGroup>
              </Col>
              <Col md={6}>
                <FormGroup>
                  <ControlLabel>หน่วยนับ</ControlLabel>
                  <FormControl onChange={this.onFormChange.bind(this,'unit')} value={data.unit!==null?data.unit:''} />
                </FormGroup>
              </Col>
            </Row>
            <Row>
              <Col md={6}>
                <FormGroup>
                  <ControlLabel>หมายเลขสินทรัพย์ <Button bsStyle='link' onClick={()=>{}}>(คลิ๊กเพื่อสร้างรหัส)</Button></ControlLabel>
                  <FormControl onChange={this.onFormChange.bind(this,'asset_code')} value={data.asset_code!==null?data.asset_code:''} />
                </FormGroup>
              </Col>
              <Col md={6}>
                <FormGroup>
                  <ControlLabel>หมายเลขซีเรียล</ControlLabel>
                  <FormControl onChange={this.onFormChange.bind(this,'serial_no')} value={data.serial_no!==null?data.serial_no:''} />
                </FormGroup>
              </Col>
            </Row>
            <Row>
              <Col md={6}>
                <FormGroup>
                  <ControlLabel>ราคาซื้อ (บาท)</ControlLabel>
                  <FormControl className='text-center' onChange={this.onFormChange.bind(this,'cost_per_unit')} value={data.cost_per_unit!==null?data.cost_per_unit:''} />
                </FormGroup>
              </Col>
              <Col md={6}>
                <FormGroup>
                  <ControlLabel>อายุการใช้งาน</ControlLabel>
                  <Form horizontal>
                    <FormGroup>
                      <Col sm={5}>
                        <FormControl  />
                      </Col>
                      <Col sm={1}>
                        ปี
                      </Col>
                      <Col sm={5}>
                        <FormControl  />
                      </Col>
                      <Col sm={1}>
                        เดือน
                      </Col>
                    </FormGroup>
                  </Form>  
                </FormGroup>
              </Col>
            </Row>
            <Row>
              <Col md={6}>
                <FormGroup>
                  <ControlLabel>วันที่ซื้อ</ControlLabel>
                  <DatePicker 
                    maxWidth='100%'
                    showIcon={true}
                    showFooter={true}
                    popPlacement='bottom'
                    buddhistEra
                    value={data.purchase_date}
                    onChange={this.onDateChange.bind(this,'purchase_date')}
                  />    
                </FormGroup>
              </Col>
              <Col md={6}>
                <FormGroup>
                  <ControlLabel>สภาพปัจจุบัน</ControlLabel>
                  <FormControl onChange={this.onFormChange.bind(this,'')} value={data.remark!==null?data.remark:''} />
                </FormGroup>
              </Col>
            </Row>
            <Row>
              <Col md={6}>
                <FormGroup>
                  <ControlLabel>วันที่เริ่มใช้ครั้งแรก</ControlLabel>
                  <DatePicker 
                    maxWidth='100%'
                    showIcon={true}
                    showFooter={true}
                    popPlacement='bottom'
                    buddhistEra
                    value={data.first_used_date}
                    onChange={this.onDateChange.bind(this,'first_used_date')}
                  />
                </FormGroup>
                <FormGroup>
                  <ControlLabel>วันที่ย้ายทะเบียนรถล่าสุด</ControlLabel>
                  <DatePicker 
                    maxWidth='100%'
                    showIcon={true}
                    showFooter={true}
                    popPlacement='bottom'
                    buddhistEra
                    value={data.last_used_date}
                    onChange={this.onDateChange.bind(this,'last_used_date')}
                  />
                </FormGroup>
                <FormGroup>
                  <ControlLabel>ทะเบียนรถที่ใช้ครั้งสุดท้าย</ControlLabel>
                  <FormControl onChange={this.onFormChange.bind(this,'vehicle_registration_no')} value={data.vehicle_registration_no!==null?data.vehicle_registration_no:''} />
                </FormGroup>
              </Col>
              <Col md={6}>
                <Row>
                  <Col md={4}>
                    <FormGroup>
                      <ControlLabel>ภาพประกอบ</ControlLabel>
                      <div className='box-up-img'>
                        <div style={{padding:'5px'}}>
                          {this.renderImage()}
                        </div>
                      </div>
                    </FormGroup>
                  </Col>  
                </Row>    
              </Col>
            </Row>
          </Box.Body>
          {!this.props.readOnly && (
          <Box.Footer>
						<ButtonToolbar className='pull-right'>
              {asset_id!==''?<Button bsStyle='danger' onClick={()=>this.setState({showDel:true})}><FontAwesome name='trash' />&nbsp;ลบรายการ</Button>:''}
							<Button bsStyle='primary' onClick={this.onSaveClick.bind(this)}><FontAwesome name='save' />&nbsp;บันทึก</Button>
              <Button onClick={this.onClose.bind(this)}><FontAwesome name='close' />&nbsp;กลับหน้าตาราง</Button>
						</ButtonToolbar>
					</Box.Footer>)}
        </Box>  
      </div>
    )
  }

  renderHistoryTab() {
    return(<div>history</div>)
  }

  render(){
    let {activeKey,loading} = this.state
    let titleTab0 = (<div><FontAwesome name="info-o" />&nbsp;ข้อมูลทั่วไป</div>)
    let titleTab1 = (<div><FontAwesome name="warning" />&nbsp;ประวัติการใช้งาน</div>)
    return (
      <div>
        <Box loading={loading}>
          <Box.Body>
            {this.props.showInfoOnly?(
              <div>{this.renderInfoTab()}</div>
            ):(<Tabs 
              activeKey={activeKey}
              id='asset-tabs'
              onSelect={this.onTabsSelect.bind(this)}
            >
              <Switch>
                <Route exact path="/asset/work/info" render={(props) => this.renderInfoTab()}/>                            
                <Route exact path="/asset/work/history" render={(props) => this.renderHistoryTab()}/>                            
                <Route render={(props) => this.renderInfoTab()}/>                         
              </Switch>
              <Tab eventKey={'info'} title={titleTab0}></Tab>
              <Tab eventKey={'history'} title={titleTab1}></Tab>
            </Tabs>)}
          </Box.Body>  
        </Box>
        <ConfirmPopup
          show={this.state.showDel}
          message={'ยืนยันลบใบงานสินทรัพย์ '+this.state.data.asset_code+' ?'}
          onConfirm={this.onConfirmDel.bind(this)}
          onHide={()=>{this.setState({showDel:false})}}
        />
        <AssetEditCategoryModal
          ref='categoryModal'
          show={this.state.showCat}
          catId={this.state.data.category}
          cateAdd={this.state.typeCat}
          onNewCategory={this.onNewCategory.bind(this)}
          onNewSubCategory={this.onNewSubCategory.bind(this)}
          onUpdateCategory={this.onUpdateCategory.bind(this)}
          onUpdateSubCategory={this.onUpdateSubCategory.bind(this)}
          onHide={this.onCategoryCloseClick.bind(this)}
        />
        <NotificationSystem ref="notificationSystem" />
      </div>
    )
  }
}

AssetDoc.defaultProps = {
  showTb:false,  
  readOnly:false,
  action:"",
  showInfoOnly:false,
  onClose:()=>{}
}

const _Connect = connect(
  (state) => ({messages: state.message.view.asset.AssetDoc}),null,null,{withRef:true}
)(AssetDoc);

export default withRouter(_Connect)

// const mapStateToProps = (state) => ({
//   store: state,
// });

// const _Connect = connect(
//     mapStateToProps
// )(AssetDoc);

// export default withRouter(_Connect) 





// WEBPACK FOOTER //
// ./src/view/asset/AssetDoc.js